import Marquee from "react-fast-marquee";

const ITEMS = [
  "Private French lessons",
  "Katy · Houston · Online",
  "FLE — all levels",
  "AP French",
  "TEF & TCF",
  "Conversation",
  "Pronunciation",
  "Culture & etiquette",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-sand py-6 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="font-serif italic text-2xl lg:text-3xl text-gold/90 mx-8 whitespace-nowrap">
            {item} <span className="text-navy/30 not-italic ml-16">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
